/* WEEGO landing v2: galería, packs, WhatsApp, barra fija y sistema de movimiento (scroll, parallax, cinta). */
(function () {
  var root = document.documentElement;
  root.classList.add('w2-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function gallery(hero) {
    var track = hero.querySelector('.w2-gal__track');
    var thumbs = hero.querySelectorAll('.w2-gal__thumb');
    if (!track || !thumbs.length) return;
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var s = track.children[i];
        if (s) track.scrollTo({ left: s.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    var cur = 0;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      if (i === cur) return;
      cur = i;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }, { passive: true });
  }

  function packs(hero) {
    var cta = hero.querySelector('[data-w2-cta]');
    var tr = hero.querySelector('[data-w2-trbtn]');
    var trPrice = hero.querySelector('[data-w2-trprice]');
    var sticky = document.querySelector('[data-w2-sticky-txt]');
    var stickyPrice = document.querySelector('[data-w2-sticky-price]');
    var qty = hero.querySelector('[data-w2-qty]');
    function update() {
      var c = hero.querySelector('.w2-pack input:checked');
      if (!c) return;
      var label = c.getAttribute('data-label') || '';
      var price = c.getAttribute('data-price') || '';
      // Cada opción es una cantidad del mismo producto: el formulario manda id + quantity.
      if (qty) qty.value = c.value;
      if (cta) cta.textContent = label + ' · ' + price;
      if (sticky) sticky.textContent = label;
      if (stickyPrice) stickyPrice.textContent = price;
      if (tr) {
        var off = parseInt(tr.getAttribute('data-off'), 10) || 0;
        var dto = '$' + Math.round((parseInt(c.getAttribute('data-cents'), 10) || 0) / 100 * (100 - off) / 100).toLocaleString('es-CO');
        var msg = (tr.getAttribute('data-msg') || '')
          .replace('{pedido}', label).replace('{total_dto}', dto).replace('{total}', price).replace('{descuento}', off);
        tr.setAttribute('href', (tr.getAttribute('data-base') || '') + '?text=' + encodeURIComponent(msg));
        if (trPrice) trPrice.textContent = dto;
      }
    }
    hero.addEventListener('change', function (e) {
      if (e.target && e.target.matches('.w2-pack input')) update();
    });
    update();
  }

  // El pedido contra entrega lo toma el formulario de Releasit; si la app no cargó, sigue el flujo normal.
  function codForm(hero) {
    var form = hero.querySelector('#w2-form');
    if (!form) return;
    var cta = form.querySelector('button[name="add"]');
    function open(e) {
      var b = document.getElementById('_rsi-buy-now-button');
      if (!b) return;
      e.preventDefault();
      // La primera apertura tarda mientras Releasit prepara el pedido; weego2-cod.js quita la espera al abrir.
      if (cta) {
        cta.classList.add('is-loading');
        setTimeout(function () { cta.classList.remove('is-loading'); }, 7000);
      }
      b.click();
    }
    form.addEventListener('submit', open);
    var stickyBtn = document.querySelector('.w2-sticky .w2-btn');
    if (stickyBtn) stickyBtn.addEventListener('click', open);
  }

  function stickyBar() {
    var bar = document.querySelector('.w2-sticky');
    var anchor = document.getElementById('w2-oferta');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var e = en[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(anchor);
  }

  /* Apariciones al hacer scroll. Los hijos de [data-w2-stagger] entran en cascada. */
  function reveal() {
    document.querySelectorAll('[data-w2-reveal]').forEach(function (el) {
      if (!el.hasAttribute('data-w2-anim')) el.setAttribute('data-w2-anim', 'up');
    });
    document.querySelectorAll('[data-w2-stagger]').forEach(function (box) {
      var type = box.getAttribute('data-w2-stagger') || 'up';
      Array.prototype.forEach.call(box.children, function (child, i) {
        if (!child.hasAttribute('data-w2-anim')) child.setAttribute('data-w2-anim', type);
        child.style.setProperty('--d', Math.min(i, 8) * 90 + 'ms');
      });
    });
    var els = document.querySelectorAll('[data-w2-anim], .w2-head, .w2-compare, .w2-inside__visual, .w2-final, .w2-faq__side');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('w2-in', 'w2-drawn'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.remove('w2-pending');
        el.classList.add('w2-in');
        if (el.matches('.w2-head') || el.querySelector('.w2-scribble')) setTimeout(function () { el.classList.add('w2-drawn'); }, 250);
        var d = parseInt(el.style.getPropertyValue('--d'), 10) || 0;
        setTimeout(function () { el.style.setProperty('--d', '0ms'); }, d + 1000);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    var vh = window.innerHeight;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > vh * 0.92) el.classList.add('w2-pending');
      io.observe(el);
    });
  }

  /* Parallax suave, barra de progreso y cinta que se inclina según la velocidad del scroll. */
  function scrollFx() {
    if (reduce) return;
    var px = Array.prototype.slice.call(document.querySelectorAll('[data-w2-parallax]'));
    var bar = document.querySelector('.w2-progress span');
    var ribbons = Array.prototype.slice.call(document.querySelectorAll('.w2-ribbon'));
    var lastY = window.scrollY, skew = 0, ticking = false;
    function frame() {
      ticking = false;
      var y = window.scrollY, vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var f = parseFloat(el.getAttribute('data-w2-parallax')) || 0.1;
        var off = (r.top + r.height / 2 - vh / 2) * f;
        el.style.setProperty('--w2-py', off.toFixed(1) + 'px');
      });
      if (bar) {
        var max = document.documentElement.scrollHeight - vh;
        bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(y / max, 1) : 0) + ')';
      }
      var v = y - lastY; lastY = y;
      skew += (Math.max(-8, Math.min(8, v * 0.25)) - skew) * 0.2;
      ribbons.forEach(function (rb) { rb.style.setProperty('--w2-sk', skew.toFixed(2) + 'deg'); });
      if (Math.abs(skew) > 0.05) request();
    }
    function request() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    request();
  }


  /* Videos: cargan al entrar en pantalla y se reproducen solos, sin sonido, solo mientras se ven. */
  function autoVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('[data-w2-autoplay] video'));
    if (!vids.length) return;
    function load(v) { if (v.dataset.src && !v.getAttribute('src')) { v.setAttribute('src', v.dataset.src); } }
    vids.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { load(v); if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          load(v);
          if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '0px 120px 0px 120px', threshold: 0.01 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function heroIntro() {
    var h = document.querySelector('.w2-hero');
    if (!h) return;
    setTimeout(function () { h.classList.add('w2-drawn'); }, reduce ? 0 : 1100);
  }

  function boot() {
    document.querySelectorAll('.w2-hero').forEach(function (h) { gallery(h); packs(h); codForm(h); });
    stickyBar();
    reveal();
    scrollFx();
    autoVideos();
    heroIntro();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
